module.exports = __webpack_public_path__ + "img/scream.c7120302.gif";